<script setup lang="ts">
import {
	RouterLink,
} from '@hybridly/vue'

withDefaults(defineProps<{
	variant?: 'primary' | 'secondary' | 'link'
	loading?: boolean
	href?: string
}>(), {
	variant: 'primary',
	loading: false,
	href: undefined,
})
</script>

<template>
	<component
		:is="href ? RouterLink : 'button'"
		:href="href"
		:disabled="loading"
		class="disabled:cursor-not-allowed"
		:class="{
			'focus-visible:primary-indigo-600 inline-flex items-center gap-x-2 bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2': variant === 'primary',
			'inline-flex items-center gap-x-2 bg-gray-800 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400': variant === 'secondary',
			'focus-visible:primary-indigo-600 text-primary hover:text-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2': variant === 'link',
		}"
	>
		<slot v-if="!loading" />

		<i-gg-spinner v-if="loading" class="mx-auto size-5 animate-spin" />
	</component>
</template>
